import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Tab from './Tab';
import { useInitialNavTabState } from './utils';
import './styles/nav-tabs.scss';

const NavTab = ({
    items = [],
    onTabSelected = Object.getPrototypeOf(Function),
    gtmAttribute = null,
}) => {
    const { initialSelectedTab, initialContent } = useInitialNavTabState(items);
    const [navItems, setNavItems] = useState(items);
    const [selectedTab, setSelectedTab] = useState(initialSelectedTab);
    const [content, setContent] = useState(initialContent);

    const handleTabSelected = (tabIndex, data = null) => {
        if (tabIndex === selectedTab) {
            return;
        }

        const updatedNavItems = navItems.map((navItem, index) => {
            if (index === tabIndex) {
                return {
                    ...navItem,
                    selected: true,
                };
            }

            if (index === selectedTab) {
                return {
                    ...navItem,
                    selected: false,
                };
            }

            return navItem;
        });

        setNavItems(updatedNavItems);
        setSelectedTab(tabIndex);

        if (updatedNavItems[tabIndex].render) {
            setContent(navItems[tabIndex].render());
        }

        if (onTabSelected) {
            onTabSelected(tabIndex, data);
        }
    };

    return (
        <>
            <nav className="nav-tabs">
                {navItems.map((navItem, index) => (
                    <Tab
                        key={`NavItemTab-${index}`}
                        options={navItem}
                        onTabSelected={() => handleTabSelected(index, navItem?.data)}
                        gtmAttribute={navItem?.gtmAttribute || gtmAttribute}
                    />
                ))}
            </nav>
            <div>{content}</div>
        </>
    );
};

NavTab.propTypes = {
    items: PropTypes.arrayOf(PropTypes.object).isRequired,
    onTabSelected: PropTypes.func,
    gtmAttribute: PropTypes.string,
};

export default NavTab;
